// Pure keyboard-navigation helpers for the WAI-ARIA menu pattern (FR-022a).
// Extracted so unit tests can exercise the traversal logic without a DOM.

export type NavAction =
  | { kind: 'focus'; index: number }
  | { kind: 'activate'; index: number }
  | { kind: 'close' }
  | { kind: 'noop' }

/**
 * Resolve a keydown event into an abstract nav action.
 *
 *   ArrowDown → focus next (wraps)
 *   ArrowUp   → focus previous (wraps)
 *   Home      → focus first
 *   End       → focus last
 *   Enter     → activate current
 *   Space     → activate current
 *   Escape    → close
 *
 * @param key        `KeyboardEvent.key` string
 * @param currentIndex current focused index
 * @param itemCount  total number of visible menuitems
 */
export function resolveMenuNav(key: string, currentIndex: number, itemCount: number): NavAction {
  if (itemCount <= 0) {
    if (key === 'Escape') return { kind: 'close' }
    return { kind: 'noop' }
  }
  switch (key) {
    case 'ArrowDown':
      return { kind: 'focus', index: (currentIndex + 1) % itemCount }
    case 'ArrowUp':
      return { kind: 'focus', index: (currentIndex - 1 + itemCount) % itemCount }
    case 'Home':
      return { kind: 'focus', index: 0 }
    case 'End':
      return { kind: 'focus', index: itemCount - 1 }
    case 'Enter':
    case ' ':
    case 'Space':
      return { kind: 'activate', index: currentIndex }
    case 'Escape':
      return { kind: 'close' }
    default:
      return { kind: 'noop' }
  }
}
